import Network from '../../common/network'
import React from 'react';
import Utils from '../../common/utils';
import List from '@material-ui/core/List';
import ClampLines from 'react-clamp-lines'
import DataSource from 'common/dataStore'
import Constants from 'common/constants'
import Analytics from 'analytics';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import NativeAgent from 'common/nativeAgent'

const LOG_PREFIX = '##news'

const NEWS_BASE_URL = 'https://hapi.newsprompt.co/HomePageExtension/getApiArticles?maxno=100&ldesc=128'
const NEWS_BASE_URL_WEATHER = 'https://hapi.newsprompt.co/HomePageExtension/getApiArticles?actno=104&maxno=100&d=newsprompt.co&ldesc=159&sec=weather&origin=web&v=1.0'

var tagsSet = [];

export default class News extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            newsItems: [],
            selectedTag: "ALL",
            isLoading: false,
            newsClickCount: 0
        };
    }

    componentDidMount() {
        this.fetchNewsItems()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.shouldShowWeatherNews !== this.props.shouldShowWeatherNews) {
            this.setState({ newsItems: [] })
            this.fetchNewsItems()
        }
    }

    parseNewsItems(resultSet) {
        var newsItems = []
        resultSet.forEach(element => {
            newsItems.push(new NewsItem(element));
        })
        return newsItems;
    }

    fetchNewsItems() {
        var newsData;
        var newsUrl = NEWS_BASE_URL
        var tag = 'general_news'
        if (this.props.shouldShowWeatherNews === true) {
            newsUrl = NEWS_BASE_URL_WEATHER;
            tag = 'weather_news'
        }
        newsData = DataSource.getItem(tag);
        var lastFetchTimestamp = DataSource.getItem(tag + "_last_fetch_timestamp");
        if (Utils.isNull(newsData) === false) {//Show the news anyway and update once you have the new one
            this.setState({ newsItems: newsData });
        }

        if (!DataSource.getItem(Constants.GENERAL_NEWS_REFRESH) && this.hasNewsThresholdPassed(lastFetchTimestamp) === false) {
            return;
        }


        this.setState({
            isLoading: true
        });

        newsData = []

        Network.fetchWithTimeout(newsUrl)
            .then((response) => {
                if (false === response.ok) {
                    throw Error(response.statusText)
                }
                return response.json()
            })
            .then((resp) => {
                let results = resp['resultSet']
                if (Utils.isNull(results)) {
                    throw new Error("Did not get success as true")
                }

                let formattedData = this.parseNewsItems(results)
                DataSource.setItem(tag, formattedData);
                DataSource.setItem(tag + "_last_fetch_timestamp", Date.now());
                DataSource.setItem(Constants.GENERAL_NEWS_REFRESH, false);
                this.setState(
                    {
                        newsItems: formattedData,
                        isLoading: false
                    });
            })
            .catch((e) => {
                console.log(LOG_PREFIX, e);
                this.setState(
                    {
                        isLoading: false
                    });
            })
    }

    hasNewsThresholdPassed(lastFetchTimestamp) {
        if (Utils.isNull(lastFetchTimestamp)) {
            return true;
        }
        return Date.now() - lastFetchTimestamp > 60 * 60 * 1000;
    }

    onNewsItemClicked(news) {
        Analytics.sendEvent(
            Constants.ANALYTICS.EVENTS.CATEGORY.CLICK,
            Constants.ANALYTICS.EVENTS.ACTION.NEWS_CLICK,
            news.target
        )
        const { newsClickCount: count } = this.state

        if (count === 3) {
            NativeAgent.initiateInterstitialAdsCall(news.target)
            this.setState({
                newsClickCount: 0
            })
        } else {
            this.setState({
                newsClickCount: count + 1
            })
            window.open(news.target, '_blank');
        }
    }

    render() {
        tagsSet = []
        tagsSet.push("ALL");
        for (var i = 0; i < this.state.newsItems.length; i++) {
            tagsSet.push(this.state.newsItems[i]['category']);
        }

        tagsSet = tagsSet.filter(function (v, i, self) {
            return i === self.indexOf(v);
        });
        return (
            <div>
                {this.fetchCategoryTags()}
                <List component="nav" className="news-scroll">
                    <div className="news-loader-wrapper" style={this.state.isLoading === true && this.state.newsItems.length === 0 ? {} : { display: "none" }}>
                        <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                    </div>
                    {this.state.newsItems.filter(news =>
                        this.state.selectedTag === "ALL" || news.category === this.state.selectedTag).slice(0, 8).map((news => {
                            return (
                                <div className="news-block-wrap" onClick={() => this.onNewsItemClicked(news)} key={this.state.selectedTag + news.imageUrl + news.target}>
                                    <div className="news-components-wrapper">
                                        <div className="news-components-blocks">
                                            <div className="image-wrapper">
                                                <div className="news-image">
                                                    <LazyLoadImage
                                                        alt=""
                                                        src={news.imageUrl}
                                                        placeholderSrc={"/image/placeholder.png"}
                                                    ></LazyLoadImage>
                                                </div>
                                            </div>
                                            <div className="content-wrapper">
                                                <ClampLines
                                                    text={news.text}
                                                    lines={2}
                                                    ellipsis="..."
                                                    className="title"
                                                    buttons={false}
                                                />
                                                <div className="readmore">
                                                    <a onClick={() => this.onNewsItemClicked(news)}>Read More</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }))}
                </List>
            </div>
        );
    }

    fetchCategoryTags() {
        if (this.props.shouldShowWeatherNews === true) {
            return (<div></div>);
        }
        var toShow = []

        tagsSet.forEach(element => {
            toShow.push(
                <td id={element} onClick={this.onTagClicked.bind(this, element)} key={element}>
                    <div className={element === this.state.selectedTag ? "news-tags active" : "news-tags"} ><span>{element === "usnews" ? "US News" : element}</span></div>
                </td >
            )
        }
        );
        return (<table className="table-news-scroll">
            <tbody><tr>{toShow}</tr></tbody>
        </table>);
    }

    onTagClicked(tag) {
        this.setState({ selectedTag: tag });
        Analytics.sendEvent(
            Constants.ANALYTICS.EVENTS.CATEGORY.CLICK,
            Constants.ANALYTICS.EVENTS.ACTION.TOGGLE_NEWS,
            tag
        )
    }
}

class NewsItem {
    constructor(data) {
        this.target = data['u'];
        this.text = data['t'];
        this.description = data['desc'];
        this.imageUrl = data['imgr'];
        this.site = data['site'];
        this.category = data['ccategory'];
    }
}



// WEBPACK FOOTER //
// ./src/components/news/newsComponent.js